import React from 'react'
import PropTypes from 'prop-types'

import FormManager from 'src/core/gd-form/common/form-manager'
import DateRangeCalendar from "../../gd-components/datetime/gd-daterange-picker/components/daterange-calendar"

class SelectDateRange extends React.Component {

    static propTypes = {
        params: PropTypes.shape({
            btnNoValueLabel : PropTypes.string,

            btnSomeday      : PropTypes.bool,
            btnTomorrow     : PropTypes.bool,
            btnToday        : PropTypes.bool,
            btnNoValue      : PropTypes.bool,

            onSubmit        : PropTypes.func.isRequired,
        })
    }

    constructor(props) {
        super(props)

        const initFormData = {
            range: null
        }

        const formStructure = {
            fields: {
                range: {
                    type: 'select',
                    isRequired: false
                }
            },
            onSubmit: this.onSubmit
        }

        this.form = new FormManager(formStructure,initFormData)
    }

    onSubmit = (result) => {
        this.props.params.onSubmit(result.range)
    }

    onDateRangeSelected = (moment) => {
        this.form.setValue('range', moment)
        this.form.onSubmitClick()
    }

    render() {
        const value = this.form.getValue('range')

        const presets = []
        if (this.props.params.btnNoValue) {
            presets.push(
                {label: this.props.params.btnNoValueLabel, onClick: ()=>{this.onDateRangeSelected(null)}}
            )
        }

        return (
            <div className="gd-form-modal">
                <div className="row p-h-0">
                    <DateRangeCalendar className        = "daterange-picker-calendar"
                                       presets          = {presets}
                                       selectedRange    = {value}
                                       minDate          = {this.props.params.minDate}
                                       maxDate          = {this.props.params.maxDate}
                                       onSelect         = {this.onDateRangeSelected}/>
                </div>
            </div>
        );
    }
}

module.exports = SelectDateRange
